import { ReactNode } from "react";
import { cn } from "../../../utils/class-names";

interface AssetContainerProps {
  className?: string;
  children?: ReactNode;
  ["data-cy"]?: string;
}

export function AssetContainer({
  className,
  children,
  ["data-cy"]: dataCy,
}: AssetContainerProps): JSX.Element {
  return (
    <div
      className={cn("flex flex-col gap-5 @screen-sm:gap-8", className)}
      data-cy={dataCy}
    >
      {children}
    </div>
  );
}

interface DetailsContainerProps {
  className?: string;
  children?: ReactNode;
}

export function DetailsContainer({
  className,
  children,
}: DetailsContainerProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-col gap-5 @[1350px]:flex-row @[1350px]:items-start @[1350px]:gap-10",
        className
      )}
    >
      {children}
    </div>
  );
}
